/**
 * Binom dynamic URL tokens. Click in the token panel to append to a URL.
 * Sourced from the public Binom token reference + observed panel chips.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

export const BINOM_URL_TOKENS = [
  '{click_id}',
  '{campaign_key}',
  '{lp_key}',
  '{offer_id}',
  '{aff_network_id}',
  '{aff_network_name}',
  '{country_code}',
  '{geo}',
  '{ts_id}',
  '{device}',
  '{browser}',
  '{os}',
  '{cost}',
  '{payout}',
] as const;

export type BinomUrlToken = (typeof BINOM_URL_TOKENS)[number];

export function appendBinomTokenToUrl(url: string, token: string): string {
  if (!token) return url;
  if (url.includes(token)) return url;
  const sep = url.includes('?') ? '&' : '?';
  const param = token.replace(/^\{|\}$/g, '');
  if (!url) return token;
  return `${url}${sep}${param}=${token}`;
}
